export default "__VITE_ASSET__B1Tubc0C__"